
import { ISelectOption } from 'app/interfaces/ISelectOption';
import { Type } from 'shell-models-lib';

export const enum EncryptionMethod {
    NoEncryption = 0,
    SSL = 1,
    RequestSSL = 6
}

export enum SSLMode {
    Disable = 0,
    Allow = 1,
    Perfer = 2, // default
    Require = 3,
    VerifyCa = 4,
    VerifyFull = 5
}

export type PostGreSqlAdditionalFieldType = 'schema' | 'pooling' | 'connectionTimeout' | 'commandTimeout' | 'trustServerCertificate' | 'sslCertificate' | 'sslKey' | 'sslPassword' | 'readBufferSize' | 'logParameters' | 'timezone' | 'encoding';

export const sslModeOptions: Array<ISelectOption<SSLMode>> = [
    {
        label: stringResources.Disabled,
        value: SSLMode.Disable
    },
    {
        label: stringResources.SSL_Mode_Allow,
        value: SSLMode.Allow
    },
    {
        label: stringResources.SSL_Mode_Preferred,
        value: SSLMode.Perfer
    },
    {
        label: stringResources.Required,
        value: SSLMode.Require
    },
    {
        label: stringResources.SSL_Mode_Verify_Ca,
        value: SSLMode.VerifyCa
    },
    {
        label: stringResources.SSL_Mode_Verify_Full,
        value: SSLMode.VerifyFull
    }
];

export type PostGreSqlAdditionalPropertiesKeyType =
    | 'schema'
    | 'pooling'
    | 'connectionTimeout'
    | 'commandTimeout'
    | 'trustServerCertificate'
    | 'sslCertificate'
    | 'sslKey'
    | 'sslPassword'
    | 'readBufferSize'
    | 'logParameters'
    | 'timezone'
    | 'encoding';

export const additionalFieldsKeyOptions: Array<ISelectOption<PostGreSqlAdditionalPropertiesKeyType>> = [
    {
        label: 'Schema', // Do not need localization, Refer to the official documentation, the initials are capitalized. https://www.npgsql.org/doc/connection-string-parameters.html
        value: 'schema',
        type: Type.String
    },
    {
        label: 'Pooling',
        value: 'pooling',
        type: Type.Boolean
    },
    {
        label: 'Connection Timeout',
        value: 'connectionTimeout',
        type: Type.Int
    },
    {
        label: 'Command Timeout',
        value: 'commandTimeout',
        type: Type.Int
    },
    {
        label: 'Trust Server Certificate',
        value: 'trustServerCertificate',
        type: Type.Boolean
    },
    {
        label: 'SSL Certificate',
        value: 'sslCertificate',
        type: Type.String
    },
    {
        label: 'SSL Key',
        value: 'sslKey',
        type: Type.String
    },
    {
        label: 'SSL Password',
        value: 'sslPassword',
        type: Type.String
    },
    {
        label: 'Read Buffer Size',
        value: 'readBufferSize',
        type: Type.Int
    },
    {
        label: 'Log Paramters',
        value: 'logParameters',
        type: Type.Boolean
    },
    {
        label: 'Timezone',
        value: 'timezone',
        type: Type.String
    },
    {
        label: 'Encoding',
        value: 'encoding',
        type: Type.String
    }
];

export const additionalFieldsAllowedKeys = additionalFieldsKeyOptions.map((option) => option.value);

export const encryptionMethodOptions: Array<ISelectOption<EncryptionMethod>> = [
    {
        label: stringResources.Postgresql_Encryption_Method_No_Encryption,
        value: EncryptionMethod.NoEncryption
    },
    {
        label: stringResources.Postgresql_Encryption_Method_SSL,
        value: EncryptionMethod.SSL
    },
    {
        label: stringResources.Postgresql_Encryption_Method_RequestSSL,
        value: EncryptionMethod.RequestSSL
    }
];

export function convertToEncryptionMethod(mode: string | undefined): EncryptionMethod {
    if (mode == null) {
        return EncryptionMethod.NoEncryption;
    }
    switch (mode.toUpperCase()) {
        case '0':
        case 'NoEncryption':
            return EncryptionMethod.NoEncryption;
        case '1':
        case 'SSL':
            return EncryptionMethod.SSL;
        case '6':
        case 'RequestSSL':
            return EncryptionMethod.RequestSSL;
        default:
            return EncryptionMethod.NoEncryption;
    }
}

export function convertToValidateServerCertificate(validate: string | undefined): boolean {
    if (validate == null) {
        return true;
    }
    switch (validate.toUpperCase()) {
        case '0':
        case 'DISABLED':
            return false;
        case '1':
        case 'ENABLED':
            return true;
        default:
            return true;
    }
}
